// Modules
import React from "react";
import filter from ".././../../Assests/Img/filter-list.png";
// Styles
import "./MvFilterBtn.sass";

type Props = {
  onClick(): void;
}

class MvFilterBtn extends React.Component<Props> {

  render() {
    const {onClick} = this.props;

    return (
      <button className="mv-filter-btn" onClick={onClick}>
        <p className="mx-auto filter-label"><img className="filter-icon" src={filter} alt="filter-icon"/>  <span className="text">Filter & Sort</span> </p>
      </button>
    );
  }
}

export default MvFilterBtn;
